import { useFormContext } from 'react-hook-form';
import { Textarea } from '@/components/ui/textarea';
import { X } from 'lucide-react';
import type { AppointmentFormValues } from '@/types/appointment-form';

export function NoteSection() {
  const { watch, setValue } = useFormContext<AppointmentFormValues>();
  const comment = watch('comment') ?? '';

  return (
    <div className="px-6 py-4 border-t border-border-subtle">
      {/* Label row + remove (×). Flutter's InternalNoteWidget is a plain
          labeled text field — no AI affordance. */}
      <div className="flex items-center justify-between mb-2">
        <label className="text-xs font-medium text-text-muted">
          Internal note
        </label>
        <button
          type="button"
          onClick={() => setValue('comment', null)}
          className="p-1 hover:bg-grey-100 rounded"
          aria-label="Remove note"
        >
          <X className="h-4 w-4 text-status-error" />
        </button>
      </div>

      <Textarea
        placeholder="Add a note (visible to staff only)..."
        value={comment}
        onChange={(e) => setValue('comment', e.target.value)}
        className="text-sm min-h-[64px] resize-none"
        maxLength={500}
      />
      <p className="text-xs text-text-hint mt-1 text-right">{comment.length}/500</p>
    </div>
  );
}
